import { createSlice } from '@reduxjs/toolkit';
import { INCREMENT_UNSEEN_COUNT, CLEAR_UNSEEN_COUNT_FOR_CHANNEL } from '../../../constants/VisitorActionTypes';
import { receivedIncomingMessageAction } from '../../../actions/ChatActions/receivedIncomingMessage';
import { PUBLISH_MESSAGE } from '../../../pubsub/constants/asyncActionTypes';
import { CREATE_NEW_THREAD } from '../../../thread-create/constants/actionTypes';
import { PARTIAL_MESSAGE } from 'conversations-message-history/partial-message/constants/messageTypes';
const initialState = {
  dismissed: true,
  count: 0,
  suppressUntilCleared: false
};
const newMessagePreviewPopupSlice = createSlice({
  name: 'newMessagePreviewPopup',
  initialState,
  reducers: {
    dismissNewMessagePreviewPopup: state => {
      state.dismissed = true;
      state.count = 0;
    }
  },
  extraReducers: builder => {
    builder.addCase(receivedIncomingMessageAction, (state, action) => {
      var _action$payload$messa;
      // Skip visitor messages, playback, and partial chunks — they must never
      // open the popup or be counted.
      if (!action.payload.shouldNotify || ((_action$payload$messa = action.payload.message) === null || _action$payload$messa === void 0 ? void 0 : _action$payload$messa['@type']) === PARTIAL_MESSAGE) {
        return;
      }
      // While the new-thread suppress is active, silently drop all agent
      // messages (the entire opening sequence from the bot).
      if (state.suppressUntilCleared) {
        return;
      }
      state.dismissed = false;
    });
    builder.addCase(INCREMENT_UNSEEN_COUNT, state => {
      if (!state.dismissed) {
        state.count += 1;
      }
    });
    // New thread: suppress ALL bot messages until the user reads them.
    builder.addCase(CREATE_NEW_THREAD.SUCCEEDED, state => {
      state.dismissed = true;
      state.count = 0;
      state.suppressUntilCleared = true;
    });
    // User read the messages (widget opened / tab focused while open).
    builder.addCase(CLEAR_UNSEEN_COUNT_FOR_CHANNEL, state => {
      state.suppressUntilCleared = false;
    });
    // User replied without opening the widget — lift suppress so the bot's
    // next response can show in the popup, then reset display state.
    builder.addCase(PUBLISH_MESSAGE.SUCCEEDED, state => {
      state.suppressUntilCleared = false;
      state.dismissed = true;
      state.count = 0;
    });
  }
});
export const {
  dismissNewMessagePreviewPopup
} = newMessagePreviewPopupSlice.actions;
export default newMessagePreviewPopupSlice.reducer;